import './App.css';
import Home from '../src/pages/Home';
import About from '../src/pages/About';
import Contact from './pages/Contact';
// import Products from './pages/Products';
import Cart from './pages/Cart';
import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './Cartcontext';

function App() {
  return (
    <CartProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/products" element={<Products />} /> */}
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </div>
    </CartProvider>
  );
}

export default App;